module.exports = {"name":"videojs5-brighcove","type":"adapter","tech":"js","author":"Jordi Aguilar","version":"6.1.0","built":"2017-10-25","repo":"https://bitbucket.org/npaw/brightcove-videojs5-adapter-js","libVersion":"6.1.0","features":{"buffer":"monitor","seek":"monitor","getters":["getDuration","getTitle"]},"ads":[{"buffer":"monitor","seek":"monitor","getters":["getPlayhead"],"filename":"brightcove-ads.js"}]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 16
// module chunks = 0